import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

const Layout = ({ children, className }) => {
  return (
    <section className={`block w-full ${className ? className : ''}`}>
      {children}
    </section>
  )
}

Layout.propTypes = propTypes

export default Layout
